import { sanitizeURL } from '../utils/sanitizeURL';

interface AppConfigItem {
  readonly containerApiUrl: string;
  readonly microApiUrl: string;
  readonly auth: {
    readonly region: string;
    readonly userPoolId: string;
    readonly userPoolWebClientId: string;
    readonly oauth: {
      readonly domain: string;
      readonly scope: string[];
      readonly redirectSignIn: string;
      readonly redirectSignOut: string;
      readonly responseType: string;
      readonly urlOpener: (url: string) => void;
    };
  };
  readonly vantiv: {
    readonly PAY_PAGE_ID: string;
  };
}

interface AppConfig extends AppConfigItem {
  readonly appName: string;
}

const urlOpener = (url: string): void => {
  const urlToOpen = sanitizeURL(url);

  if (urlToOpen) {
    window.open(urlToOpen, '_self');
  }
};

const localhost: AppConfigItem = {
  containerApiUrl: 'https://local-racpad.rentacenter.com/api',
  microApiUrl: 'https://local-altam-racpad.rentacenter.com/api',
  auth: {
    region: 'us-east-1',
    userPoolId: 'us-east-1_FPWut7aB',
    userPoolWebClientId: '608s8dso4aecka8omjpukssq3n',
    oauth: {
      domain: 'auth-local-racpad.auth.us-east-1.amazoncognito.com',
      scope: ['phone', 'email', 'profile'],
      redirectSignIn: 'http://localhost:3003',
      redirectSignOut: 'http://localhost:3003',
      responseType: 'token',
      urlOpener
    }
  },
  vantiv: {
    PAY_PAGE_ID: 'uwrjGM3KiuKcqyAs'
  }
};

const localhostIE11: AppConfigItem = { ...localhost };

export const local: AppConfigItem = {
  containerApiUrl: 'https://local-racpad.rentacenter.com/api',
  microApiUrl: 'https://local-altam-racpad.rentacenter.com/api',
  auth: {
    region: 'us-east-1',
    userPoolId: 'us-east-1_FPWut7aB',
    userPoolWebClientId: '608s8dso4aecka8omjpukssq3n',
    oauth: {
      domain: 'auth-local-racpad.auth.us-east-1.amazoncognito.com',
      scope: ['phone', 'email', 'profile'],
      redirectSignIn: 'https://local-altam-racpad.rentacenter.com',
      redirectSignOut: 'https://local-altam-racpad.rentacenter.com',
      responseType: 'token',
      urlOpener
    }
  },
  vantiv: {
    PAY_PAGE_ID: 'uwrjGM3KiuKcqyAs'
  }
};

const dev: AppConfigItem = {
  containerApiUrl: 'https://dev-racpad.rentacenter.com/api',
  microApiUrl: 'https://dev-altam-racpad.rentacenter.com/api',
  auth: {
    region: 'us-east-1',
    userPoolId: 'us-east-1_8MbOyEYG6',
    userPoolWebClientId: '47r2ihk9fehcpn9t64thdbu2tl',
    // userPoolId: 'us-east-1_IX7X5lZqL',
    // userPoolWebClientId: '4o7nqktg06c45g59dqhd51gik5',
    oauth: {
      // domain: 'auth-dev-racpad.auth.us-east-1.amazoncognito.com',
      domain: 'auth-qa-racpad.auth.us-east-1.amazoncognito.com',
      scope: ['phone', 'email', 'profile'],
      redirectSignIn: 'https://dev-altam-racpad.rentacenter.com',
      redirectSignOut: 'https://dev-altam-racpad.rentacenter.com',
      responseType: 'token',
      urlOpener
    }
  },
  vantiv: {
    PAY_PAGE_ID: 'uwrjGM3KiuKcqyAs'
  }
};

const qa: AppConfigItem = {
  containerApiUrl: 'https://qa-racpad.rentacenter.com/api',
  microApiUrl: 'https://qa-altam-racpad.rentacenter.com/api',
  auth: {
    region: 'us-east-1',
    userPoolId: 'us-east-1_8MbOyEYG6',
    userPoolWebClientId: '47r2ihk9fehcpn9t64thdbu2tl',
    oauth: {
      domain: 'auth-qa-racpad.auth.us-east-1.amazoncognito.com',
      scope: ['phone', 'email', 'profile'],
      redirectSignIn: 'https://qa-altam-racpad.rentacenter.com',
      redirectSignOut: 'https://qa-altam-racpad.rentacenter.com',
      responseType: 'token',
      urlOpener
    }
  },
  vantiv: {
    PAY_PAGE_ID: 'uwrjGM3KiuKcqyAs'
  }
};

const uat: AppConfigItem = {
  containerApiUrl: 'https://uat-racpad.rentacenter.com/api',
  microApiUrl: 'https://uat-altam-racpad.rentacenter.com/api',
  auth: {
    region: 'us-east-1',
    userPoolId: 'us-east-1_FBmCthpda',
    userPoolWebClientId: '1d8vgr67fr7gli9abpv9j1cb3n',
    oauth: {
      domain: 'auth-uat-racpad.auth.us-east-1.amazoncognito.com',
      scope: ['phone', 'email', 'profile'],
      redirectSignIn: 'https://uat-altam-racpad.rentacenter.com',
      redirectSignOut: 'https://uat-altam-racpad.rentacenter.com',
      responseType: 'token',
      urlOpener
    }
  },
  vantiv: {
    PAY_PAGE_ID: 'uwrjGM3KiuKcqyAs'
  }
};

const prod: AppConfigItem = {
  containerApiUrl: 'https://racpad.rentacenter.com/api',
  microApiUrl: 'https://racpad-configs.rentacenter.com/api',
  auth: {
    region: 'us-east-1',
    userPoolId: 'us-east-1_so5RR57Of',
    userPoolWebClientId: '50nk6ibf5lru47hesk4j0cfuu4',
    oauth: {
      domain: 'auth-racpad.auth.us-east-1.amazoncognito.com',
      scope: ['phone', 'email', 'profile'],
      redirectSignIn: 'https://racpad-altam.rentacenter.com',
      redirectSignOut: 'https://racpad-altam.rentacenter.com',
      responseType: 'token',
      urlOpener
    }
  },
  vantiv: {
    PAY_PAGE_ID: 'Fjm8Xzn5DhtCg9Sy'
  }
};

const artifact: AppConfigItem = {
  containerApiUrl: '_apiUrls.container',
  microApiUrl: '_apiUrls.micro',
  auth: {
    region: '_auth.region',
    userPoolId: '_auth.userPoolId',
    userPoolWebClientId: '_auth.userPoolWebClientId',
    oauth: {
      domain: '_auth.oauth.domain',
      scope: ['phone', 'email', 'profile'],
      redirectSignIn: '_auth.oauth.redirectSignIn',
      redirectSignOut: '_auth.oauth.redirectSignOut',
      responseType: '_auth.oauth.responseType',
      urlOpener
    }
  },
  vantiv: {
    PAY_PAGE_ID: '_vantiv.payPageId'
  }
};

let appConfigItem: AppConfigItem;

switch (process.env.REACT_APP_STAGE) {
  case 'localhost':
    appConfigItem = localhost;
    break;
  case 'localhost-ie11':
    appConfigItem = localhostIE11;
    break;
  case 'local':
    appConfigItem = local;
    break;
  case 'dev':
    appConfigItem = dev;
    break;
  case 'qa':
    appConfigItem = qa;
    break;
  case 'uat':
    appConfigItem = uat;
    break;
  case 'prod':
    appConfigItem = prod;
    break;
  case 'artifact':
    appConfigItem = artifact;
    break;
  default:
    appConfigItem = localhost;
    break;
}

export const appConfig: AppConfig = {
  appName: 'Payment',
  ...appConfigItem
};
